//CSS
import '../../Components/Page/Page.css'
import './ESpec.css';
import Flex from '../../Images/Slides/Flex1Slide6.png'
import SlideComp from '../../Components/SlideComp/SlideComp';

//React
import React from 'react';
import SecHeader from '../../Components/SecHeader/SecHeader';


const Espec: React.FC = () => {
    return (
        <div id="Goals">
            <SecHeader title={"E-SPEC"} />
                <SlideComp source={Flex} />
        </div>
    );
};

export default Espec;